import {IHttpService} from "angular";
import {SecurityTradingSystemIndicators} from "../models/SecurityTradingSystemIndicators";

export class TradingSystemsService {

    public static id = "tradingSystemsService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {

    }

    public async list(): Promise<Array<SecurityTradingSystemIndicators>> {
        const url = "/tradefloor/api/trading-system/dashboard";
        const response = await this.$http.get<Array<SecurityTradingSystemIndicators>>(url);
        return response.data!;
    }
}
